import { Cell, Grid, HeadingSection, InfoLabel, Text } from 'bold-ui'
import { booleanToSimNaoTitleCase } from 'components/form'
import { SituacaoDeRua } from 'graphql/types.generated'
import { quantidadeAlimentacaoDiariaRecord, tempoSituacaoRuaRecord } from 'types/enums'
import { isObjectDeepEmpty } from 'util/object'
import { formatJoinRespostas, formatSimNaoJoinRespostas } from 'view/cidadao/utils-cidadao'

import { higienePessoalRecord, origemAlimentacaoRecord } from '../../create/types/model-cidadao'

interface SituacaoDeRuaSectionProps {
  situacaoDeRua: SituacaoDeRua
}

export function SituacaoDeRuaSection(props: Readonly<SituacaoDeRuaSectionProps>) {
  const { situacaoDeRua } = props

  const { id: _id, __typename, ...rest } = situacaoDeRua ?? {}
  const isSituacaoDeRuaVazio = isObjectDeepEmpty(rest)

  if (!situacaoDeRua.stSituacaoDeRua || isSituacaoDeRuaVazio) {
    return (
      <HeadingSection level={2} title='Situação de rua'>
        <Text fontStyle='italic'>Sem informações registradas</Text>
      </HeadingSection>
    )
  }

  return (
    <HeadingSection level={2} title='Situação de rua'>
      <Grid wrap>
        <Cell size={4}>
          <InfoLabel title='Tempo em situação de rua'>
            {tempoSituacaoRuaRecord[situacaoDeRua?.tempoSituacaoDeRua]}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Recebe benefício'>
            {booleanToSimNaoTitleCase(situacaoDeRua?.recebeAlgumBeneficio)}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Possui referência familiar'>
            {[booleanToSimNaoTitleCase(situacaoDeRua?.possuiReferenciaFamiliar)]}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Refeições por dia'>
            {quantidadeAlimentacaoDiariaRecord[situacaoDeRua?.quantidadeAlimentacaoDiaria]}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Origem da alimentação'>
            {formatJoinRespostas(situacaoDeRua?.origemAlimentacao?.map((item) => origemAlimentacaoRecord[item]))}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Acompanhado por instituição'>
            {formatSimNaoJoinRespostas(
              situacaoDeRua?.stAcompanhadoOutraInstituicao,
              situacaoDeRua?.instituicaoAcompanhamento
            )}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Tem acesso a higiene pessoal'>
            {formatSimNaoJoinRespostas(
              situacaoDeRua?.stAcessoHigienePessoal,
              situacaoDeRua?.higienePessoal?.map((item) => higienePessoalRecord[item])
            )}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Visita familiar'>
            {formatSimNaoJoinRespostas(
              situacaoDeRua?.stVisitaFamiliarComFrequencia,
              situacaoDeRua?.grauParentescoVisitaFamiliar
            )}
          </InfoLabel>
        </Cell>
        <Cell size={4} />
      </Grid>
    </HeadingSection>
  )
}
